var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGatsbyImageData = exports.ImageElement = void 0;
const react_1 = __importDefault(require("react"));
const gatsby_plugin_image_1 = require("gatsby-plugin-image");
const get_gatsby_image_data_1 = require("./get-gatsby-image-data");
Object.defineProperty(exports, "getGatsbyImageData", { enumerable: true, get: function () { return get_gatsby_image_data_1.getGatsbyImageData; } });
exports.ImageElement = react_1.default.memo(function ImageElement({ image, width, height, layout, backgroundColor, sizes, aspectRatio, options, alt, ...props }) {
    var _a;
    const imageData = (0, get_gatsby_image_data_1.getGatsbyImageData)({
        image,
        width,
        height,
        layout,
        backgroundColor,
        sizes,
        aspectRatio,
        options,
    });
    alt = (_a = alt !== null && alt !== void 0 ? alt : image.description) !== null && _a !== void 0 ? _a : '';
    return react_1.default.createElement(gatsby_plugin_image_1.GatsbyImage, { image: imageData, ...props, alt: alt });
});
//# sourceMappingURL=index.js.map